// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3M8Rz","index":"styles_index__312xg"};